import React, { useEffect, useState } from "react";
import SelectDropdown from "components/forms/select-dropdown";
import DateRange from "components/ui/date-range";
import { connect } from "react-redux";
import { selectors } from "reducers";
import { Spinner } from "components/ui";
import PropTypes from "prop-types";

const CoachScorecardFilters = ({
  fetchData,
  teamNameOptions = [],
  onboardingCoaches = [],
  isFetching,
  initialFilters = {}
}) => {
  const [filters, setFilters] = useState({});
  const [filteredOnboardingCoaches, setFilteredOnboardingCoaches] = useState(
    []
  );

  const setDateFrom = (date) => {
    setFilters({ ...filters, DateFrom: date });
  }

  const setDateTo = (date) => {
    setFilters({ ...filters, DateTo: date });
  }

  const setInitialDates = () => {
    const today = new Date();
    const priorDate = new Date(new Date().setDate(today.getDate() - 120));
    setDateFrom(priorDate);
    setDateTo(today);
  }

  useEffect(() => {
    setFilters(initialFilters);
    setFilteredOnboardingCoaches(onboardingCoaches);
    setInitialDates()
  }, []);


  return (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        padding: "5px",
        marginRight: "10px"
      }}
    >
      <span style={{ marginRight: "10px", fontSize: "15px" }}>
        Team:
        <SelectDropdown
          options={[{ text: "", value: "" }, ...teamNameOptions]}
          value={filters.TeamId || ""}
          onChange={team => {
            setFilters({ ...filters, TeamId: team });
            if (team == "") setFilteredOnboardingCoaches(filteredOnboardingCoaches);
            else {
              setFilteredOnboardingCoaches(
                onboardingCoaches.filter(x => x.team == team)
              );
            }
          }}
        />
      </span>
      <span style={{ marginRight: "10px", fontSize: "15px" }}>
        Coach:
        <SelectDropdown
          options={[{ text: "", value: "" }, ...filteredOnboardingCoaches]}
          value={filters.CoachId || ""}
          onChange={team => {
            setFilters({ ...filters, CoachId: team });
          }}
        />
      </span>

      <span style={{ marginRight: "10px", fontSize: "15px" }}>
          Date Range:
          <DateRange
            startDate={filters.DateFrom}
            endDate={filters.DateTo}
            setStartDate={setDateFrom}
            setEndDate={setDateTo}
            handleSubmit={() => {}}
            showSubmit={false}
          />
        </span>

      <button
        type="buttpm"
        style={{
          padding: "0.5rem 2rem",
          marginTop: "35px",
          borderRadius: "3px"
        }}
        onClick={() => {
          fetchData(filters);
        }}
        disabled={isFetching}
      >
        Submit
      </button>
      {isFetching && <Spinner />}
    </div>
  );
};

CoachScorecardFilters.propTypes = {
  fetchData: PropTypes.func.isRequired,
  teamNameOptions: PropTypes.array.isRequired,
  onboardingCoaches: PropTypes.array.isRequired,
  isFetching: PropTypes.bool.isRequired,
  companyId: PropTypes.string,
  initialFilters: PropTypes.object
};

export default connect(state => ({
  teamNameOptions: selectors.getTeamNameOptions(state),
  onboardingCoaches: selectors.getOnboardingCoaches(state)
}))(  CoachScorecardFilters);